/**
 * Dynamic modal that is shared between blocks and archive templates
 */
export default function () {
	const debug = false;

	const modal = document.getElementById('js-modal-people');                      // modal element
	let modalPhotograph = modal.querySelector('.modal--modal--visual');            // the src value
	let modalSocial = modal.querySelector('.modal--modal--social');                // visibility
	let modalLinkedin = modal.querySelector('.modal--modal--linkedin');            // the href value
	let modalName = modal.querySelector('.modal--modal--name');                    // text
	let modalLeadTitle = modal.querySelector('.modal--modal--title');              // text
	let modalCountry = modal.querySelector('.modal--modal--country');              // text
	let modalCompany = modal.querySelector('.modal--modal--company');              // text
	let modalJobTitle = modal.querySelector('.modal--modal--job-title');           // text
	let modalBio = modal.querySelector('.modal--modal--description-text');         // text
	let modalYears = modal.querySelector('.modal--modal--years');                  // text
	let modalEmail = modal.querySelector('.modal--modal--email');                  // text
	let modalForum = modal.querySelector('.modal--modal--forum');                  // text
	let modalOptional = modal.querySelector('.modal--modal--optional');            // text
	let modalOptionalOther = modal.querySelector('.modal--modal--optional-other'); // text

	function populateModal(evt) {
		debug ? console.log('Opening people modal') : false;

		evt.preventDefault();

		// Data values captured from the anchor instances
		let photograph = this.getAttribute('data-photograph');
		let linkedin = this.getAttribute('data-linkedin');
		let name = this.getAttribute('data-name');
		let title = this.getAttribute('data-title');
		let country = this.getAttribute('data-country');
		let forum = this.getAttribute('data-forum');
		let forum_req = this.getAttribute('data-forum-req');
		let job_title = this.getAttribute('data-job-title');
		let company = this.getAttribute('data-company');
		let optional = this.getAttribute('data-optional');
		let optional_other = this.getAttribute('data-optional-other');
		let years = this.getAttribute('data-years');
		let email = this.getAttribute('data-email');
		let bio = this.getAttribute('data-bio');

		// Always present
		modalName.textContent = name;
		modalLeadTitle.textContent = title;

		// Almost always is present
		modalPhotograph.src = photograph;

		// Conditional, shown after the photograph
		if (linkedin) {
			// Inject the social LinkedIn anchor with some relative information
			modalLinkedin.href = linkedin;
			modalLinkedin.title = name + ' LinkedIn';
			modalLinkedin.textContent = name;
		} else {
			// Otherwise, don't show the LinkedIn link
			modalSocial.classList.add('empty');
		}

		// Column 1 (only shown for Global Leadership)
		forum ? (modalForum.querySelector('.modal--modal-text').textContent = forum) : '';
		forum_req ? (modalForum.querySelector('.modal--modal-text').textContent = forum_req) : '';

		// Hide the column if empty fields (hidden column for Fellows)
		(forum === null && forum_req === null) ? modalForum.classList.add('empty') : false;

		// Column 2 (if column 1 is present this will be column 2, otherwise it will be column 1)
		company ? (modalCompany.querySelector('.modal--modal-text').textContent = company) : (modalCompany.querySelector('.modal--modal-text, .modal--modal-label').classList.add('empty'));
		job_title ? (modalJobTitle.textContent = job_title) : (modalJobTitle.classList.add('empty'));

		// All of these are bulked into an "Optional Fields" container (no specific order)
		years ? (modalYears.textContent = years) : (modalYears.classList.add('empty'));
		email ? (modalEmail.href = 'mailto:' + email) : (modalEmail.classList.add('empty'));
		email ? (modalEmail.textContent = email) : (modalEmail.classList.add('empty'));
		country ? (modalCountry.textContent = country) : (modalCountry.classList.add('empty'));
		optional ? (modalOptional.textContent = optional) : (modalOptional.classList.add('empty'));
		optional_other ? (modalOptionalOther.textContent = optional_other) : (modalOptionalOther.classList.add('empty'));

		function nl2br(str) {
			return str.replace(/\n/g, '<br/>');
		}

		// Convert the '\n' to <br/>
		modalBio.innerHTML = nl2br(bio);

		// Add the styles to the modal to show it, along with the <body> class
		modal.style.display = 'block';
		modal.classList.add('active');
		modal.querySelector('.modal--modal--slide').classList.add('active');
		document.documentElement.classList.add('modal-is-open');
	}

	function stripModalValues() {
		debug ? console.log('Stripping previous values from the modal...') : false;

		// Reset image source
		modalPhotograph.src = '';

		// Reset text/href content for modal elements
		modalLinkedin.href = '';
		modalLinkedin.title = '';
		modalName.textContent = '';
		modalLeadTitle.textContent = '';
		modalCountry.textContent = '';
		modalCompany.querySelector('.modal--modal-text').textContent = '';
		modalJobTitle.textContent = '';
		modalBio.innerHTML = '';
		modalYears.textContent = '';
		modalEmail.href = '';
		modalForum.querySelector('.modal--modal-text').textContent = '';
		modalOptional.textContent = '';
		modalOptionalOther.textContent = '';

		// Remove 'empty' class from all elements
		modal.querySelectorAll('.empty').forEach(function (element) {
			element.classList.remove('empty');
		});
	}

	function closeModal(evt) {
		evt.preventDefault();

		debug ? console.log('People modal close button clicked') : false;

		stripModalValues(); // Reset modal values

		modal.classList.remove('active');
		modal.querySelector('.modal--modal--slide').classList.remove('active');
		document.documentElement.classList.remove('modal-is-open');

		if (modal) {
			var hiddenElements = modal.getElementsByClassName('empty');

			for (var j = 0; j < hiddenElements.length; j++) {
				var hiddenElement = hiddenElements[j];
				hiddenElement.classList.remove("empty");
			}
		}
	}

	// Listen for the people modal initiators
	document.querySelectorAll('.js-people-modal').forEach(function (trigger) {
		trigger.addEventListener('click', populateModal);
	})

	// Add click event listener to the close button
	document.getElementById('js-modal-people-close').addEventListener('click', closeModal);

	// Add event listener to close modal when clicking outside of it
	document.addEventListener('click', function (event) {
		if (event.target === modal) {
			closeModal(event);
		}
	});
}
